import React from 'react';
import './Footer.css';

import { Logo, Newsletter } from '../../components';

import { Link } from 'react-router-dom';
import { FaFacebookF, FaYoutube } from 'react-icons/fa6';



const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="box-container">
        
          {/* Event Information & Social Media Links */}
          <div className="footer-item">

            {/* Event Logo */}
            <Logo />

            {/* Event Description */}
            <p>Empowering Youth to Learn Engineering and Embrace the thrill of competition, forge international connections, and let your robots pave the way to victory.</p>

            {/* Social Media Links */}
            <div className="social">
              <a href="https://www.facebook.com/worldrobotgames" target='_blank' rel="noreferrer"><FaFacebookF /></a>
              <a href="https://www.youtube.com/@WRG-RobotGames" target='_blank' rel="noreferrer"><FaYoutube /></a>
            </div>

            {/* Newsletter component to subscribe */}
            {/* <Newsletter variant='dark' idPrefix='2' /> */}

          </div>

          {/* Quick Links */}
          <div className="footer-item">
            <h2>Quick Links</h2>
            <div className="links">
              <p><Link to="/about">About Us</Link></p>
              <p><Link to="/tickets">Registration</Link></p>
              <p><Link to="/speakers">Speakers</Link></p>
              <p><Link to="/schedule">Schedule</Link></p>
              <p><Link to="/blog">Blogs</Link></p>
              <p><Link to="/contact">Contact Us</Link></p>
              <p><Link to="https://wrg2025-tw.v7rc.io/">中文版</Link></p>
            </div>
          </div>

        </div>
      </div>

      {/* Footer Copyright */}
      <div className="content">
        <p>Designed By V7 Idea Technology Ltd. | All Rights Reserved</p>
      </div>

    </footer>
  );
};

export default Footer;